module.exports = __webpack_public_path__ + "img/partners-banner.287120e5.jpg";